module.exports = __webpack_public_path__ + "static/media/play.09393d13.svg";